const ANALYTICS_BASE = '/analytics';
const ROI_BASE = `${ANALYTICS_BASE}/roi`;

// URLS
export const URLs = {
  ANALYTICS_DASHBOARD: `${ANALYTICS_BASE}/dashboard`,
  AUTO_RECALL_ANALYTICS: `${ANALYTICS_BASE}/auto-recall`,
  MESSAGING_ANALYTICS: `${ANALYTICS_BASE}/messaging`,
  PHONE_ANALYTICS: `${ANALYTICS_BASE}/phone`,
  PRACTICE_ANALYTICS_BASE: `${ANALYTICS_BASE}/practice`,
  PRACTICE_ANALYTICS_MAIN: `${ANALYTICS_BASE}/practice/main`,
  ROI_APPOINTMENT_REMINDERS: `${ROI_BASE}/appointment-reminders`,
  ROI_BULK_TEXT: `${ROI_BASE}/bulk-text`,
  ROI_MISSED_CALL_TEXT: `${ROI_BASE}/missed-call-text-conversion`,
  ROI_NO_SHOW_RATE: `${ROI_BASE}/no-show-rate`,

  CALL_INTEL_BASE: '/analytics/call-intelligence',
  CALL_INTEL_MAIN_PAGE: '/analytics/call-intelligence/main',
  CALL_INTEL_SUBSCRIBE: '/portal/subscriptions/call-intelligence',

  PRACTICE_ANALYTICS_FEEDBACK:
    'https://feedback.getweave.com/forums/952282-analytics/suggestions/47770865-practice-analytics',
  PRACTICE_ANALYTICS_HELP: 'https://www.weavehelp.com/weavehelp/article/using-practice-analytics',
  PRACTICE_ANALYTICS_SUBSCRIBE: '/portal/subscriptions/practice-analytics',

  // Analytics Action URLs
  BULK_MESSAGES: '/bulk/all-campaigns/text/new',
  QUICK_FILL: 'https://www.weavehelp.com/hc/en-us/articles/360061238691',
} as const;

// Fixed values
export const DEFAULT_HOURS = 'all-hours';
export const DEFAULT_FIELD_EMPTY_VALUE = '-';
export const VERY_SMALL_MODE_WIDTH_THRESHOLD = 500;
